import {toMinorUnit} from "../../../helpers/currency";
import {serializeToUrl} from "../../../helpers/helpers";
import {setLoading} from "../../../actions/loading";
import {addAlert, addServerErrors} from "../../../actions/ui";
import {wrappedFetch} from '../../../helpers/fetch';
import {saveInsuranceOption, setReservationData} from "../../../actions/reservation";
import {updateStripePaymentIntent} from "../../../actions/payment";
import {GATEWAY_TYPE_STRIPE} from "@showclix-shared/Payment/constants/gatewayTypes";
import {getInsurancePayload} from "../../../selectors/request";

export function getInsuranceQuote() {
  return (dispatch, getState) => {
    let state = getState();

    if (state.insurance?.provider === "ticketguardian") {
      if (state.insurance.insuranceItems?.length != 0) {
        return getTicketGuardianQuote(dispatch, state);
      }
    } else if (state.insurance?.provider === "protect") {
      if (state.insurance.insuranceItems?.length != 0) {
        return getProtectQuote(dispatch, state);
      }
    }
  }
}

function getTicketGuardianQuote(dispatch, state) {
  dispatch(setLoading("TICKETGUARDIAN_QUOTE_REQUEST"));
  let key = state.insurance.key;
  let currency = state.reservation.total_cost.currency;

  let data = {
    'items[]': state.insurance.insuranceItems,
    currency
  };

  let params = serializeToUrl(data);
  return wrappedFetch(`${state.ui.apiUrl}/insurance/ticket-guardian/${key}/quote?${params}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
    },
    credentials: 'same-origin',
  }).then((response) => {
    return response.json();
  }).then((response) => {
    dispatch(setInsurancePrice(+toMinorUnit(response.quote, currency)));
    dispatch(setLoading("TICKETGUARDIAN_QUOTE_SUCCESS"));
  }).catch((e) => {
    dispatch(setLoading("TICKETGUARDIAN_QUOTE_FAILURE"));
  });
}

function getProtectQuote(dispatch, state) {
  dispatch(setLoading("PROTECT_QUOTE_REQUEST"));
  let key = state.insurance.key;
  let currency = state.reservation.total_cost.currency;
  let reservation_id = state.reservation.reservation_id;
  let quote_id = state.insurance.quoteId;

  let data = {
    reservation_id,
    currency
  };
  if (quote_id != '') {
    data.quote_id = quote_id;
  }

  let params = serializeToUrl(data);
  return wrappedFetch(`${state.ui.apiUrl}/insurance/protect/${key}/quote?${params}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
    },
    credentials: 'same-origin',
  }).then((response) => {
    return response.json();
  }).then((response) => {
    dispatch(setInsurancePrice(+toMinorUnit(response.quote, currency)));
    dispatch(setInsuranceQuoteId(response.quoteId));
    dispatch(setLoading("PROTECT_QUOTE_SUCCESS"));
  }).catch((e) => {
    dispatch(setLoading("PROTECT_QUOTE_FAILURE"));
  });
}

export function setInsurancePrice(price) {
  return {type: "SET_INSURANCE_PRICE", price};
}

export function setInsuranceQuoteData(quoteData) {
  return {type: 'SET_INSURANCE_QUOTE_DATA', quoteData};
}

export function setInsuranceQuoteId(quoteId) {
  return {type: 'SET_INSURANCE_QUOTE_ID', quoteId};
}


export function setInsurancePolicy(selected, options = {}) {
  return {type: "SET_INSURANCE_POLICY", selected, options};
}

export function setInsuranceOption(event) {
  return {type: 'SET_INSURANCE_OPTION', event};
}

export function processInsuranceResponse(res) {
  return async (dispatch, getState) => {
    const state = getState();
    const {secret} = state.reservation;

    if (res.quoteDiffer) {
      dispatch(addAlert(res.quoteDiffer, 'warning'));
    }

    if (res.reservation_data) {
      dispatch(setReservationData(secret, res.reservation_data));

      if (state.payment.gatewayType === GATEWAY_TYPE_STRIPE) {
        const {total_cost} = getState().reservation;
        await dispatch(
          updateStripePaymentIntent(total_cost?.amount || 0,
            {
              payment_intent_id: state.payment.stripePaymentIntentId,
              client_secret: state.payment.stripePaymentIntentSecret,
            }
          ),
        );
      }
    }

    dispatch(setLoading("INSURANCE_SUBMIT_SUCCESS"));
  }
}

export function submitInsuranceOption() {
  return async (dispatch, getState) => {
    const state = getState();
    const insurancePayload = getInsurancePayload(state);

    dispatch(setLoading("INSURANCE_OPTION_REQUEST"));

    try {
      const res = await dispatch(saveInsuranceOption({
        'data': {
          'attributes': insurancePayload
        }
      }));

      await dispatch(processInsuranceResponse(res.body));
      dispatch(setLoading("INSURANCE_OPTION_SUCCESS"));
    } catch (e) {
      dispatch(setLoading("INSURANCE_OPTION_FAILURE"));
      dispatch(addServerErrors(e.response.body.errors));
    }
  }
}
